<template>
  <div>
    <div class="common-box" style="border-top:none;">
      <el-row class="row-one">
        <span class="row-one-title">我关注的理财顾问</span>
      </el-row>
      <!-- 无数据 -->
      <div v-if="!followShow" class="dataNo">
        <img src="../../assets/images/advisor5.png" alt="">
        <div class="dataNo-con">
          <p>您还没有关注的理财顾问！</p>
<!--          <a href="https://www.myfund.com/investmentAdviser.html" class="aColor" target="_blank">去搜索 > </a>-->
          <router-link :to="{name:'financialAdvisorList'}"><a class="aColor" target="_blank">去搜索 ></a></router-link>
        </div>
      </div>
      <!-- 有数据 -->
      <div v-else class="recommend one">
        <ul class="recommend-con clearfix">
          <li class="clearfix" v-for="(item,i) in followLists" :key="i">
            <div class="recommend-message fl">
              <img :src="item.headImg" alt="">
              <div class="recommend-button" @click="adviserCode = item.AdviserCode;dialogVisable2 = true">取消关注</div>
              <a :href="'https://www.myfund.com/consultantDetails.html?id=' + item.AdviserCode" class="recommend-button" style="background:#fff;color: #236EAC;" target="_blank">了解更多</a>
            </div>
            <div class="recommend-details fl">
              <div class="recommend-details-tit">
                <span style="font-size: 20px;font-weight: bold;margin-right:12px;">{{item.AdviserName}}</span>
                <span style="font-size: 18px;">{{$commonJs.dataLeftCompleting(3, "0", item.AdviserCode)}}</span>
              </div>
              <p><span>地区:</span><i>{{item.Province + item.City}}</i></p>
              <p><span>从业时间:</span><i>{{item.ExperienceTime + '年'}}</i></p>
              <p><span>服务客户:</span><i>{{item.CustomerCount+'人'}}</i></p>
              <p><span>优势:</span><i style="text-align: justify;">{{item.Advantage}}</i></p>
              <p><span>邮箱:</span><i>{{item.Email}}</i></p>
              <!-- <p><span>联系方式:</span><i>{{item.Phone}}</i></p> -->
            </div>
            <div class="recommend-apply" v-show="applyshow">
              <img src="../../assets/images/advisor4.png" alt="">
              <span class="aColor" @click="application(item)"> 申请为专属理财顾问</span>
            </div>
          </li>
        </ul>
        <!-- 页码 -->
        <el-pagination class="pagination-single" @current-change="handleCurrentChange" @size-change="handleSizeChange" :current-page.sync="page" :page-size="pageNum" layout="prev, pager, next" :total="total" hide-on-single-page>
        </el-pagination>
      </div>

    </div>
    <!-- 为您推荐 -->
    <div class="recommend two w">
      <div class="recommend-tit clearfix">
        <div class="recommend-tit-left">
          <div class="recommend-tit-line"></div>为您推荐
        </div>
        <!-- <span class="recommend-tit-right" onclick="window.open('https://www.myfund.com/consultantPlatform.html')">查看更多 ></span> -->
      </div>
      <ul class="recommend-con clearfix">
        <li class="clearfix" v-for="(item,i) in recommendLists" :key="i">
          <div class="recommend-message fl">
            <img :src="item.headImg">
            <div class="recommend-button" @click="followClick(item)">{{item.followStatus == '已关注'? '取消关注':'+ 关注'}}</div>
            <a :href="'https://www.myfund.com/consultantDetails.html?id=' + item.AdviserCode" class="recommend-button" style="background:#fff;color: #236EAC;" target="_blank">了解更多</a>
          </div>
          <div class="recommend-details fl">
            <div class="recommend-details-tit">
              <span style="font-size: 20px;font-weight: bold;margin-right:12px;">{{item.AdviserName}}</span>
              <span style="font-size: 18px;">{{$commonJs.dataLeftCompleting(3, "0", item.AdviserCode)}}</span>
            </div>
            <p><span>地区:</span><i>{{item.Province + item.City}}</i></p>
            <p><span>从业时间:</span><i>{{item.ExperienceTime + '年'}}</i></p>
            <p><span>服务客户:</span><i>{{item.CustomerCount+'人'}}</i></p>
            <p><span>优势:</span><i style="text-align: justify;">{{item.Advantage}}</i></p>
            <p><span>邮箱:</span><i>{{item.Email}}</i></p>
            <!-- <p><span>联系方式:</span><i>{{item.Phone}}</i></p> -->
          </div>
          <div class="recommend-apply" v-show="applyshow">
            <img src="../../assets/images/advisor4.png" alt="">
            <span class="aColor" @click="application(item)"> 申请为专属理财顾问</span>
          </div>
        </li>
      </ul>
    </div>
    <!-- 申请理财顾问 -->
    <el-dialog class="dialog-single-two" :visible.sync="dialogVisable" :show-close="false" :close-on-click-modal="false">
      <div class="dialog-single-three-p">
        <img src="../../assets/images/advisor3.png" style="width:23px;height:19px;margin:-5px 8px 0 0">
        <span>申请理财顾问</span>
      </div>
      <p style="margin-top:10px;font-size:16px;">{{'【'+applyName+'】'}}</p>
      <p class="dialog-single-two-con">申请专属理财顾问后，理财顾问将有权限查看您当前的基金持有情况， 及后续交易情况，便于根据您当前的投资现状，提供相应的投资建议。</p>
      <div class="dialog-single-two-check">
        <el-checkbox v-model="checked" @change="applyChange"></el-checkbox>
        <span>如您同意以上条件，点击下方申请按钮</span>
      </div>
      <p>静待理财顾问的回应！</p>
      <p v-show="applyError" class="rColor margin-t10">请您同意以上条件，才可申请</p>

      <div class="margin-t30">
        <el-button type="normal1" @click="applyClick">申请</el-button>
        <el-button type="cancel" style="width:154px" @click="canale">取消</el-button>
      </div>
    </el-dialog>
    <!-- 取消关注 -->
    <el-dialog class="dialog-single-three" :visible.sync="dialogVisable2" :close-on-click-modal="false">
      <div class="dialog-single-three-p">确定不在关注</div>
      <div class="margin-t30">
        <el-button type="cancel" style="width:154px" @click="dialogVisable2 = false">取消</el-button>
        <el-button type="normal1" @click="changeStatus(adviserCode);dialogVisable2 = false;">确定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
export default {
  name: 'followLists',
  data () {
    return {
      followShow: false,
      followLists: [],
      page: 1,
      pageNum: 4,
      total: 0,
      dialogVisable: false,
      recommendLists: [],
      dialogVisable2: false,
      adviserCode: '',
      checked: false,
      applyCode: '',//申请理财顾问id
      applyName: '',//申请理财顾问名字
      applyError: false,
      applyshow: true
    }
  },
  mounted () {
    this.getfollowLists()
    this.getRecommend()
    this.getAdviserRelation()
  },
  methods: {
    // 理财顾问是否绑定
    getAdviserRelation () {
      this.$http.get(this.$apiPath.adviserRelation, {
        custno: this.$commonJs.getCookie('u_custno1')
      }).then(res => {
        // console.log(res);
        if (res.data.Result) {
          if (res.data.Data.Note == "申请中" || res.data.Data.Note == "未申请" || res.data.Data.Note == "结束服务" || res.data.Data.Note == "不通过") {
            this.applyshow = true
          } else {
            this.applyshow = false
          }
        }
      }).catch(err => { })
    },
    // 关注列表
    getfollowLists () {
      this.$http.get(this.$apiPath.myFollowLists, {
        custno: this.$commonJs.getCookie('u_custno1'),
        page: this.page,
        pageNum: this.pageNum
      }).then(res => {
        //   console.log(res);
        if (res.data.Result) {
          this.followLists = res.data.Data.DataList
          this.followLists.forEach(item => {
            item.headImg = item.HeadPortrait.indexOf("\\") != -1 ? 'https://www.myfund.com/' + item.HeadPortrait.split('\\')[0] + '/' + item.HeadPortrait.split('\\')[1] : item.HeadPortrait
          })
          this.followShow = this.followLists.length > 0 ? true : false
          this.total = res.data.recordCount
        }
      }).catch(err => { })
    },
    handleCurrentChange (newPage) {
      this.page = newPage
      this.getfollowLists()
    },
    handleSizeChange (newSize) {
      this.pageNum = newSize
      this.getfollowLists()
    },
    // 更改关注状态
    changeStatus (code) {
      this.$http.get(this.$apiPath.ChangeFocusStatus, {
        custno: this.$commonJs.getCookie('u_custno1'),
        adviserCode: code
      }).then(res => {
        // console.log(res);
        if (res.data.Result && res.data.Data.Note == '提交成功') {
          this.getfollowLists()
          this.getRecommend()
        }
      }).catch(err => { })
    },
    // 为您推荐
    getRecommend () {
      this.$http.get(this.$apiPath.advisorRecommend, {
        custno: this.$commonJs.getCookie('u_custno1')
      }).then(async res => {
        // console.log(res)
        if (res.data.Result) {
          for (var i = 0; i < res.data.Data.DataList.length; i++) {
            var item = res.data.Data.DataList[i]
            item.headImg = item.HeadPortrait.indexOf("\\") != -1 ? 'https://www.myfund.com/' + item.HeadPortrait.split('\\')[0] + '/' + item.HeadPortrait.split('\\')[1] : item.HeadPortrait
            item.followStatus = await this.getJodge(item.AdviserCode)
          }
          this.recommendLists = res.data.Data.DataList
        }
      }).catch(err => { })
    },
    // 判断关注
    async getJodge (code) {
      let status = ''
      await this.$http.get(this.$apiPath.judgeFollow, {
        custno: this.$commonJs.getCookie('u_custno1'),
        adviserCode: code
      }).then(res => {
        // console.log(res);
        if (res.data.Result) {
          status = res.data.Data.Note
        }
      }).catch(err => { })
      return status
    },
    followClick (val) {
      this.adviserCode = val.AdviserCode
      if (val.followStatus == '已关注') {
        this.dialogVisable2 = true
      } else {
        this.changeStatus(val.AdviserCode)
      }
    },
    // 申请理财顾问
    applyClick () {
      if (!this.checked) {
        this.applyError = true
      } else {
        this.applyError = false
        this.$http.get(this.$apiPath.applyAdviser, {
          custno: this.$commonJs.getCookie('u_custno1'),
          adviserCode: this.applyCode,
        }).then(res => {
          //   console.log(res);
          if (res.data.Result && res.data.Data.Note == "提交成功") {
            this.$message.success('请求成功，静待理财顾问的回应！')
          } else {
            this.$message.error('请求失败，请重新申请')
          }
          this.canale()
        }).catch(err => { })
      }

    },
    // 申请弹框
    application (val) {
      this.applyCode = val.AdviserCode
      this.applyName = val.AdviserName
      this.dialogVisable = true
    },
    applyChange (val) {
      if (val == true) {
        this.applyError = false
      }
    },
    // 取消
    canale () {
      this.dialogVisable = false
      this.checked = false
      this.applyError = false
    }
  }
}
</script>

<style lang="less" scoped>
.one {
  .recommend-con {
    margin: 30px 176px 0;
    li:nth-child(2n) {
      margin-right: 0;
    }
  }
}
.dataNo {
  box-sizing: border-box;
  text-align: center;
  padding-top: 100px;
  &-con p {
    font-weight: 500;
    font-size: 18px;
    color: @color3;
    margin: 10px 0;
    position: relative;
  }
}
.two {
  .recommend-con li:nth-child(3n) {
    margin-right: 0;
  }
}
.dialog-single-two {
  text-align: center;
  &-con {
    text-align: left;
    margin: 28px 40px 20px;
    font-size: 16px;
    line-height: 34px;
  }
  &-check {
    color: @color;
    margin-bottom: 10px;
    span {
      margin-left: 14px;
    }
  }
}
</style>
